import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ProdutoAnexoEntity,
    ProdutoSituacaoIntegradoEntity,
    ProdutoSituacaoGerenciamentoRiscoEntity,
    ProdutoVersaoEntity,
    SolicitacaoProcessamentoEntity
} from '../../models';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import { Observable } from "rxjs";
import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

@Injectable({ providedIn: 'root', })
export class ProdutoVersaoDataService extends CrudService<ProdutoVersaoEntity> {

    protected url: string;
    private urlReplace: string;
    private urlRetificacao: string;

    constructor(
        @Inject(OPERACAO_API_URL) public urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlReplace = `${urlBase}/v1/produto/<parent>/versao`;
        this.urlRetificacao = `${urlBase}/v1/produto/versao/retificacao`;
    }

    public withParentId(id) {
        this.url = this.urlReplace.replace('<parent>', id);
        return this;
    }

    public criarRetificacao(produtoVersaoRetificacao: ProdutoVersaoEntity) {
        return this.httpClient.post<ApiResult<ProdutoAnexoEntity>>(this.urlRetificacao, { versaoReferenciaId: produtoVersaoRetificacao.id } );
    }

    public atualizarDataReferencia(produtoVersaoRetroativa: ProdutoVersaoEntity) {
        const urlRetroativa = `${this.urlBase}/v1/produto/versao/${produtoVersaoRetroativa.id}/retroativa`;

        return this.httpClient.put<ApiResult<ProdutoAnexoEntity>>(urlRetroativa, produtoVersaoRetroativa);
    }

    public pendenteEnvioPortalUnico(){
        this.url = `${this.urlBase}/v1/produto/versao/pendentesEnvio`;
        return this;
    }

    public solicitarEnvioPortalUnico(ids: string[], senhaCertificado: string, tipoAutenticacao: EnumTipoAutenticacaoEnvioPortalUnico) {
        return this.httpClient.post<ApiResult<any>>(`${this.urlBase}/v1/Produto/versao/SolicitarEnvioPortalUnico`,
            { ids, senhaCertificado, tipoAutenticacao: <EnumTipoAutenticacaoEnvioPortalUnico>tipoAutenticacao });
    }

    public solicitarCapturaPortalUnico = (payload: FormData) =>
        this.httpClient.post<any>(`${this.urlBase}/v1/Produto/Versao/SolicitarCapturaPortalUnico`, payload);

    public obterUltimaSolicitacaoImportacaoPortalUnico = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.urlBase}/v1/Produto/Versao/CapturaPortalUnico/Atual`);

    public obterUltimaSolicitacaoExportacao = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.urlBase}/v1/Produto/Versao/Exportacao/Atual`);

    public obterUltimaSolicitacaoInativacao = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.urlBase}/v1/Produto/Versao/Inativacao/Atual`);

    public downloadRetornoExportacao = (): Observable<HttpResponse<Blob>> => {
        return this.httpClient.get(`${this.urlBase}/v1/Produto/Versao/Exportacao/Retorno`, {
            observe: 'response',
            responseType: 'blob'
        });
    }

    public getSituacaoIntegrado = () =>
        this.httpClient.get<ApiResult<ProdutoSituacaoIntegradoEntity>>(`${this.urlBase}/v1/produto/versao/Situacao/Integrados`);

    public getSituacaoGerenciamentoRisco = () =>
        this.httpClient.get<ApiResult<ProdutoSituacaoGerenciamentoRiscoEntity>>(`${this.urlBase}/v1/produto/versao/Situacao/GerenciamentoRisco`);

    public obterVersao = (versaoId: string) =>
        this.httpClient.get<ApiResult<ProdutoVersaoEntity>>(`${this.urlBase}/v1/produto/versao/${versaoId}`);

    public inativarVersaoPorProdutoId = (produtoId: string) =>
        this.httpClient.post<ApiResult<boolean>>(`${this.urlBase}/v1/Produto/${produtoId}/Versao/Inativar`, {});

    public solicitarInativacaoVersoes = (filtro: string, ordenacao: string) =>
        this.httpClient.post<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.urlBase}/v1/Produto/Versao/SolicitarInativacao`, {filtro, ordenacao});

    public removerPendencia = (produtoVersaoId: string, tipoPendencia: string) =>
        this.httpClient.post<ApiResult<boolean>>(`${this.urlBase}/v1/Produto/Versao/${produtoVersaoId}/RemoverPendencia`, {
            produtoVersaoId,
            tipoPendencia
        });
}
